export enum Actions {
  ALL = "all",
  DIRECTMESSAGE = "directMessage",
  COMMENTS = "comments",
  STORIES = "stories",
  ADS = "ads",
  EVENTS = "events",
  SPECIALDATES = "specialDates",
}

export enum WhatsAppActions {
  ALL = "all",
  WHATSAPPMESSAGE = "whatsAppMessage",
  USEREVENT = "userEvent",
  PRODUCTALERTS = "productAlerts",
  ANNIVERSARYDATES = "anniversaryDates",
  SEGMENTTRIGGERS = "segmentTriggers",
  INTEGRATIONS = "integrations",
}

export enum ActionEventsList {
  DIRECTMESSAGE = "directMessage",
  DIRECTMESSAGEADS = "directMessageOnAds",
  DIRECTMESSAGEPOSTS = "directMessageOnPosts",
  DIRECTMESSAGEREELS = "directMessageOnReels",
  COMMENTSONPOST = "commentsOnPost",
  COMMENTSONREEL = "commentsOnReel",
  COMMENTSONAD = "commentsOnAd",
  DMONAD = "dmOnAd",
  REACTIONS = "reactions",
  MENTIONS = "mentions",
  REPLIES = "replies",
  EVENTS_ENTER_SEGMENT = "events_enter_segment",
  EVENTS_EXIT_SEGMENT = "events_exit_segment",
  EVENTS_PAYLINK_UPDATE = "events_payment_link_update",
  EVENTS_CHAT_CLOSE = "events_chat_session_closed",
  KEYWORDS = "keywords",
  LAST_ORDER_DATE = "last_order_date",
  FIRST_ORDER_DATE = "first_order_date",
}

export enum WhatsappActionEventsList {
  WHATSAPPMEASSAGE = "whatsAppMessage",
  WHATSAPPCALL = "whatsAppCall",
  CLICKONWHATSAPPADS = "clickOnWhatsappAds",
  ECOMMERCE = "eEcommerce",
  ACQUISITIONS = "acquisitions",
  HELPDESK = "helpdesk",
  POSTPURCHASE = "postPurchase",
  INTEGRATIONS = "integrations",
  BACKINSTOCK = "backInStock",
  PRICEDROP = "priceDrop",
  FIRSTORDERDATE = "firstOrderDate",
  LASTORDERDATE = "lastOrderDate",
  LIFETIMEORDERVALUE = "lifetimeOrderValue",
  CUSTOMDATE = "customDate",
  SEGMENTENTRYEXIT = "segmentEntryExit",
  WEBHOOKS = "webhooks",
  EVENTSEDIT = "eventsEdit",
}

export enum LiveChatActions {
  ALL = "all",
  LIVECHATMESSAGE = "liveChatMessage",
  USEREVENT = "userEvent",
}

export enum EmailActions {
  ALL = "all",
  INBOUND = "inbound",
  OUTBOUND = "outbound",
  USEREVENT = "userEvent",
  PRODUCTALERTS = "productAlerts",
  ANNIVERSARYDATES = "anniversaryDates",
  SEGMENTTRIGGERS = "segmentTriggers",
}

export enum EmailActionEventsList {
  EMAILRECEIVED = "emailReceived",
  ECOMMERCE = "eEcommerce",
  ACQUISITIONS = "acquisitions",
  HELPDESK = "helpdesk",
  POSTPURCHASE = "postPurchase",
  INTEGRATIONS = "integrations",
  BACKINSTOCK = "backInStock",
  PRICEDROP = "priceDrop",
  FIRSTORDERDATE = "firstOrderDate",
  LASTORDERDATE = "lastOrderDate",
  LIFETIMEORDERVALUE = "lifetimeOrderValue",
  CUSTOMDATE = "customDate",
  SEGMENTENTRYEXIT = "segmentEntryExit",
}

export enum LiveChatActionEventsList {
  LIVECHATMESSAGE = "liveChatMessage",
  GENERIC_EVENT = "generic_event",
}
